exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.divToCenter[data-v-463e2771] {\n    margin: 1rem auto;\n}\n", ""]);

// exports
